module.exports = __webpack_public_path__ + "img/3.0a36eb98.png";